{
  "steplist": "רשימת צעדים"
}
